// extracted by mini-css-extract-plugin
export var active = "_af-b";
export var activeIndicator = "_af-6";
export var animate = "_af-a";
export var disabled = "_af-c";
export var flat = "_af-1";
export var fullWidth = "_af-3";
export var lg = "_af-9";
export var md = "_af-8";
export var redoButtonTabGroup = "_af-0";
export var sm = "_af-7";
export var tabButton = "_af-4";
export var tabButtonsContainer = "_af-2";
export var xs = "_af-5";